module.exports = __webpack_public_path__ + "static/img/g11.6246574.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/g11.svg
// module id = ZHke
// module chunks = 0